import './bootstrap'

import router from './anuncios_generales-routes';



new Vue({
    el: "#app"
    , router

    , data: {

    }

    , methods: {

    }
})
